"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _htmlpanel = _interopRequireDefault(require("../../components/htmlpanel.vue"));
var _relativeTime = require("../../assets/static/js/utils/relativeTime.js");
var _api = require("../../api/api");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'list-detail',
  components: {
    htmlPanel: _htmlpanel.default
  },
  props: ['colunmName', 'side_bind'],
  data: function data() {
    return {
      // session替换成cookie
      userid: (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).userId : '',
      // userid: window.sessionStorage.getItem('user')?JSON.parse(window.sessionStorage.getItem('user')).userId:'',
      lookAll: true,
      // pageUrlpc: '/pc/tpl/article/6hm6j55dchs9ntw.html',
      pageUrlpc: '',
      releaseTime: '',
      ammid: this.$route.query.ammid,
      cmmid: this.$route.query.cmmid,
      detailData: [],
      relatedPage: {
        pageno: 1,
        pagesize: 5
      },
      relatedData: [],
      relatedTipShow: false,
      relatedlength: '',
      uplousDisabled: false,
      zanImage: require("../../assets/static/img/news/newdetail_like_active.png"),
      initQCode: this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=1&id=' + this.$route.query.ammid + '&userId=' + this.userid,
      shareConfig: {
        url: '',
        title: '危化镖局-新闻资讯',
        image: 'http://www.weihuabiaoju.com/mp/images/wximg/logo-center.jpg',
        sites: ['qq', 'wechat', 'weibo'],
        wechatQrcodeTitle: '微信扫一扫',
        wechatQrcodeHelper: '<p>请用微信扫码分享</p>'
      },
      user: false
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      console.log(document.getElementById(this.side_bind).scrollHeight);
      return this.$refs.element.height > 990;
    }
  },
  created: function created() {
    var that = this;
    that.getdetailData(that.ammid);
    that.toUpchick();
    // 分享title
    // that.shareConfig.title = that.detailData.articleTitle
    // 分享url
    that.shareConfig.url = that.$root.baseUrl + '/app/cargo/ammShareMain.app?type=1&id=' + that.$route.query.ammid + '&userId=' + that.userid;
  },
  mounted: function mounted() {
    var _this = this;
    // session替换成cookie
    if ((0, _cookie.getCookie)('user')) {
      // if(window.sessionStorage.getItem('user')){
      _this.user = true;
    }
    window.addEventListener('setItem', function () {
      _this.user = true;
      console.log('user', _this.user);
    });
  },
  methods: {
    //分享到qq
    shareToqq: function shareToqq(event) {
      event.preventDefault();
      var _shareUrl = 'https://connect.qq.com/widget/shareqq/iframe_index?';
      _shareUrl += 'url=' + encodeURIComponent(this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=1&id=' + this.ammid + '&userId=' + this.userid || location.href); //分享的链接
      _shareUrl += '&title=' + encodeURIComponent('危化镖局' || document.title); //分享的标题
      window.open(_shareUrl, '_blank');
    },
    //分享到新浪微博
    shareToSinaWB: function shareToSinaWB(event) {
      event.preventDefault();
      var _shareUrl = 'http://v.t.sina.com.cn/share/share.php?'; //真实的appkey，必选参数
      _shareUrl += 'url=' + encodeURIComponent(this.initQCode || document.location); //参数url设置分享的内容链接|默认当前页location，可选参数
      _shareUrl += '&title=' + encodeURIComponent(this.title || document.title); //参数title设置分享的标题|默认当前页标题，可选参数
      _shareUrl += '&source=' + encodeURIComponent(this.initQCode || '');
      _shareUrl += '&sourceUrl=' + encodeURIComponent(this.initQCode || '');
      _shareUrl += '&content=' + 'utf-8'; //参数content设置页面编码gb2312|utf-8，可选参数
      _shareUrl += '&pic=' + encodeURIComponent('' || ''); //参数pic设置图片链接|默认为空，可选参数
      window.open(_shareUrl, '_blank');
    },
    // 阅读全文
    toLookAll: function toLookAll() {
      var that = this;
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      // let userStorage = window.sessionStorage.getItem('user')
      if (userStorage) {
        // 已登录,可阅读全文
        that.lookAll = true;
      } else {
        // 未登录,弹出登登录窗
        that.$root.loginscene = 'INFORMATION'; //注册登录场景
        that.$root.loginsceneid = that.ammid;
        that.$root.dialogFormVisible = true;
      }
    },
    //关键字搜索
    toSearch: function toSearch(searchVal) {
      this.$parent.$refs.content.scrollTop = 0;
      this.$router.push({
        name: 'search',
        query: {
          isSearch: 'true',
          isDetail: false,
          cmmid: 1,
          searchVal: searchVal
        }
      });
    },
    // 请求文章详情(chickTotalNum会自增1)
    getdetailData: function () {
      var _getdetailData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ammid) {
        var that, param, _yield$apiGetpcammdet, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              param = {
                ammId: ammid
              };
              _context.next = 4;
              return (0, _api.apiGetpcammdetail)(param);
            case 4:
              _yield$apiGetpcammdet = _context.sent;
              data = _yield$apiGetpcammdet.data;
              if (data.proCode == '200') {
                that.detailData = data.proData;
                that.pageUrlpc = data.proData.pageUrlPc.replace(that.$root.baseUrl, '');
                that.releaseTime = data.proData.articleReleaseTime;
                if (that.detailData.articleReleaseTime) {
                  // 处理发布时间
                  that.detailData.articleReleaseTime = (0, _relativeTime.getDate)(that.detailData.articleReleaseTime);
                } else {
                  that.detailData.articleReleaseTime = '未知';
                }
                // 分割关键词
                if (that.detailData.articleTagNames) {
                  that.detailData.articleTagNames = that.detailData.articleTagNames.split(',');
                }
                that.cmmid = data.proData.cmmids ? data.proData.cmmids.split(',')[0] : '';
                that.toMoreRelated(that.relatedPage.pageno, that.relatedPage.pagesize, that.ammid);
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getdetailData(_x) {
        return _getdetailData.apply(this, arguments);
      }
      return getdetailData;
    }(),
    // 文章查看数增加
    toUpchick: function () {
      var _toUpchick = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, param, _yield$apiGetArticleC, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              param = {
                ammId: that.ammid,
                sourceType: 1
              };
              _context2.next = 4;
              return (0, _api.apiGetArticleChick)(param);
            case 4:
              _yield$apiGetArticleC = _context2.sent;
              data = _yield$apiGetArticleC.data;
              if (data.proCode == '200') {
                // console.log('chickData:', data)
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function toUpchick() {
        return _toUpchick.apply(this, arguments);
      }
      return toUpchick;
    }(),
    // 文章点赞数增加
    toUplous: function () {
      var _toUplous = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, param, _yield$apiGetArticleF, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              param = {
                ammId: that.ammid
              };
              _context3.next = 4;
              return (0, _api.apiGetArticleFabulous)(param);
            case 4:
              _yield$apiGetArticleF = _context3.sent;
              data = _yield$apiGetArticleF.data;
              if (data.proCode == '200') {
                that.$message({
                  message: '点赞成功！',
                  type: 'success',
                  center: true
                });
                that.uplousDisabled = true;
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function toUplous() {
        return _toUplous.apply(this, arguments);
      }
      return toUplous;
    }(),
    // 查看更多推荐
    toMoreRelated: function () {
      var _toMoreRelated = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pageno, pagesize, ammid) {
        var param, _yield$apiGetpcRecomm, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              param = {
                pageNo: pageno,
                pageSize: pagesize,
                ammId: ammid
              };
              _context4.next = 3;
              return (0, _api.apiGetpcRecommend)(param);
            case 3:
              _yield$apiGetpcRecomm = _context4.sent;
              data = _yield$apiGetpcRecomm.data;
              if (data.proCode == '200') {
                console.log("data", data.proData.length);
                if (data.proData.length > 0) {
                  //循环处理发布时间
                  data.proData = data.proData.filter(function (item) {
                    if (item.articleReleaseTime) {
                      item.articleReleaseTime = (0, _relativeTime.getDate)(item.articleReleaseTime);
                    } else {
                      item.articleReleaseTime = '未知';
                    }
                    if (item.articleCoverStyle == 'ARTICLE_COVER_THREE') {
                      item.pictureOssUrls = item.pictureOssUrls.split(',');
                    }
                    return item;
                  });
                  this.relatedData = data.proData;
                  this.relatedlength = this.relatedData.length;
                  this.relatedPage.pageno++;
                  this.$emit('relatedData', this.relatedData);
                } else {
                  this.relatedTipShow = true;
                }
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function toMoreRelated(_x2, _x3, _x4) {
        return _toMoreRelated.apply(this, arguments);
      }
      return toMoreRelated;
    }(),
    //分享到微博
    toSinNo: function toSinNo() {
      var url = this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=1&id=' + this.detailData.ammId + '&userId=' + this.userid;
      var sharesinastring = 'http://v.t.sina.com.cn/share/share.php?title=' + this.detailData.articleTitle + '&url=' + url + '&content=utf-8&sourceUrl=' + url + '&pic=' + this.detailData.pictureOssUrls;
      window.open(sharesinastring, 'newwindow', 'height=400,width=400,top=100,left=100');
    },
    //设置lookAll
    setLookAll: function setLookAll(val) {
      if (val > 2280) {
        this.lookAll = false;
      } else {
        this.lookAll = true;
      }
    }
  }
};